import * as React from 'react'
import { IconsModel } from './iconsModel'

function SvgBottomArrow(
	{
		color,
		width = 15,
		height = 15
	}: IconsModel
) {
	return (
		<svg width={width} height={height}>
			<path
				d="M8.125 1.25v11.211l2.794-2.792.662.662-3.75 3.75a.468.468 0 01-.61.046l-.052-.046-3.75-3.75.662-.662 2.794 2.792V1.25h1.25z"
				fill={color}
				fillRule="evenodd"
			/>
		</svg>
	)
}

export default SvgBottomArrow
